import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NursegridData {
  nursegridUserId?: string;
}

export const initialState: NursegridData = {
  nursegridUserId: undefined,
};

const NursegridDataSlice = createSlice({
  name: 'nursegridData',
  initialState,
  reducers: {
    setNursegridUserId: (state, { payload }: PayloadAction<string>) => {
      state.nursegridUserId = payload;
    },
  },
});

export const { setNursegridUserId } = NursegridDataSlice.actions;

export default NursegridDataSlice.reducer;
